export default __webpack_public_path__ + "5428b9d26f4143968916b45cc191617d.svg";